import { createAction } from 'redux-actions';
import * as types from './types';

export const setPromotion = createAction(types.SET_PROMOTION);
export const resetPromotion = createAction(types.RESET_PROMOTION);
